import './Beneficiaries.less';
import {
  Row,
  Col,
  Divider,
  // Card,
  // Button,
  // Grid,
  Collapse,
} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils/languageUtils';
import KnowMoreArrowIcon from 'assets/images/home/chevron-right-red.svg';
import { useEffect, useState, Fragment } from 'react';
const { Panel } = Collapse;
// import ChevronRight from 'assets/images/home/chevron-right.svg';
import ArrowClose from 'assets/images/home/arrow-close.svg';
import ChevronUp from 'assets/images/home/chevron-up.svg';
import { BeneficiariesDaum } from 'all-in-one-shared-api/dist/apis/policy/useLifePolicyDetail';
import { formatBeneficiaries, BeneficiariesProps as formatedType } from 'utils/liPolicies';
import { useNavigate } from 'react-router-dom';
interface DividerLineProps {
  padB?: string;
  marT?: string;
}
interface BeneficiariesProps {
  beneficiaries?: BeneficiariesDaum[];
  policyNo?: string;
  companyCode?: string;
  policyStatusCode?: string;
}
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  // margin: 0 16px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const DividerLine = ({ padB, marT }: DividerLineProps) => {
  return (
    <Androw justify="start" padB={padB}>
      <AndCol style={{ width: '100%' }}>
        <AntDivider style={{ margin: '8px 0', marginTop: marT ? marT : '8px' }}></AntDivider>
      </AndCol>
    </Androw>
  );
};
const KnowMoreLinkImage = styled.img`
  margin-left: 12px;
  width: 14px;
  height: 8px;
`;
const Beneficiaries = ({ beneficiaries, policyNo, companyCode, policyStatusCode }: BeneficiariesProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const [formatedBeneficiaries, setFormatedBeneficiaries] = useState<Array<formatedType> | undefined>();
  // const formatedBeneficiaries = formatBeneficiaries(beneficiaries, isEnglish);
  const navigate = useNavigate();
  useEffect(() => {
    if (beneficiaries) {
      let d: Array<BeneficiariesDaum> = [];
      if (isEnglish) {
        d = beneficiaries.filter((item) => item.roleDesc === 'Primary Beneficiary');
      } else if (!isEnglish) {
        d = beneficiaries.filter((item) => item.roleDescTc === '基本受益人');
      }
      setFormatedBeneficiaries(formatBeneficiaries(d, isEnglish));
    }
  }, [beneficiaries, isEnglish]);
  const ExpandContent = () => {
    return (
      <div>
        {(formatedBeneficiaries && formatedBeneficiaries[0]?.relationship == 'ES') ||
        formatedBeneficiaries?.length == 0 ? (
          <div className="beneficiaries-content">
            <Androw justify="start">
              <AndCol>
                <div className="tagging">
                  <span className="letter-space4 grey-font">{t('life.policies.ownestate')}</span>
                </div>
              </AndCol>
            </Androw>
            <DividerLine></DividerLine>
          </div>
        ) : (
          <div className="beneficiaries-content">
            <Androw justify="start">
              <AndCol>
                <div className="tagging">
                  <span className="font-size17 font-setting500 grey-font">
                    {t('life.policies.Primarybeneficiaries')}
                  </span>
                </div>
              </AndCol>
            </Androw>
            <DividerLine></DividerLine>
            <Androw justify="start">
              <AndCol lg={19} md={19} sm={15} xs={15}>
                <div className="tagging">
                  <span className="font-size17 font-setting500" style={{ fontWeight: 500 }}>
                    {t('life.beneficiaries.name')}
                  </span>
                  <span className="font-size17 grey-font">{t('life.policies.relationship')}</span>
                </div>
              </AndCol>
              <AndCol span={1}>
                <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
              </AndCol>
              <AndCol lg={4} md={4} sm={7} xs={7}>
                <div
                  className="tagging"
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    padding: isEnglish ? '0' : '0 30px',
                  }}
                >
                  <span className="font-size17 font-setting500 grey-font" style={{ textAlign: 'center' }}>
                    {t('life.policies.ShareAllocation')}
                  </span>
                </div>
              </AndCol>
            </Androw>
            <DividerLine></DividerLine>
            {formatedBeneficiaries?.map((beneficiary, index) => {
              return (
                <Fragment key={index}>
                  <Androw justify="start">
                    <AndCol lg={19} md={19} sm={15} xs={15}>
                      <div className="tagging">
                        <span className="font-size17 font-setting500">
                          {beneficiary.givenName + ' ' + beneficiary.surname}
                        </span>
                        <span className="font-size17 grey-font">{beneficiary.relationshipDescTitle}</span>
                      </div>
                    </AndCol>
                    <AndCol span={1}>
                      <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
                    </AndCol>
                    <AndCol lg={4} md={4} sm={7} xs={7}>
                      <div
                        className="tagging"
                        style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '100%' }}
                      >
                        <span className="font-size20" style={{ textAlign: 'center' }}>
                          {beneficiary.share == 'Equal Share'
                            ? isEnglish
                              ? beneficiary.share
                              : '平均分配'
                            : beneficiary.share == '0%'
                            ? '-'
                            : beneficiary.share}
                        </span>
                      </div>
                    </AndCol>
                  </Androw>
                  <DividerLine></DividerLine>
                </Fragment>
              );
            })}
          </div>
        )}
      </div>
    );
  };
  const toChangeBeneficiaries = () => {
    navigate('/LIBenefiaries', {
      state: {
        policyNumber: policyNo,
        companyCode: companyCode,
      },
    });
  };
  return (
    <div className="beneficiaries-wrapper">
      <StyledBlock>
        <Androw justify="start">
          <AndCol style={{ width: '100%' }}>
            <Collapse
              className="font-size26 grey-font"
              style={{ backgroundColor: '#fff' }}
              collapsible="header"
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => {
                return isActive ? <img src={ChevronUp} /> : <img src={ArrowClose} />;
              }}
            >
              <Panel header={t('life.policies.AboutBeneficiaries')} key="1" className="grey-font">
                <ExpandContent></ExpandContent>
                {(policyStatusCode == 'MP' || policyStatusCode == 'IF' || policyStatusCode == 'AP') && (
                  <Androw
                    justify="center"
                    style={{
                      height: '49px',
                    }}
                  >
                    <AndCol style={{ cursor: 'pointer' }} onClick={toChangeBeneficiaries}>
                      <div className="view-info">
                        <span className="font-setting500 font-size17  red-font">
                          {t('life.policies.ChangeBeneficiaries')}
                        </span>
                        <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
                      </div>
                    </AndCol>
                  </Androw>
                )}
              </Panel>
            </Collapse>
          </AndCol>
          {/* <AntDivider style={{ margin: '8px 0' }}></AntDivider> */}
        </Androw>
      </StyledBlock>
    </div>
  );
};

export default Beneficiaries;
